exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-bager-kobenhavn-js": () => import("./../../../src/pages/bager-kobenhavn.js" /* webpackChunkName: "component---src-pages-bager-kobenhavn-js" */),
  "component---src-pages-bagerier-kobenhavn-js": () => import("./../../../src/pages/bagerier-kobenhavn.js" /* webpackChunkName: "component---src-pages-bagerier-kobenhavn-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

